var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'cursor-pointer':_vm.item.deleted_at == null},on:{"dblclick":function($event){return _vm.changeStatus()}}},[(_vm.statusState)?_c('b-badge',{attrs:{"variant":"success"}},[_vm._v(" منتشر شده ")]):_c('b-badge',{attrs:{"variant":"danger"}},[_vm._v("منتشر نشده")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }